import { Link, useLocation } from 'react-router-dom';
import Header from '../header/HeaderComponent';
import Footer from '../footer/FooterComponent';
import Seo from '../Seo/SeoComponent';
import styles from '../../styles/authForm.module.scss';

export default function NotFoundPage() {
    const { pathname } = useLocation();
    return (
        <div className={styles.page}>
            <Seo title="Page Not Found" description="This address does not match a NihongoTech page." path={pathname} noindex />
            <Header />
            <main className={styles.main}>
                <section className={styles.container}>
                    <div className={styles.card}>
                        <h1 className={styles.title}>Page not found</h1>
                        <p className={styles.subtitle}>This address doesn’t match a NihongoTech page.</p>
                        <Link to="/" className={styles.link}>Go to home</Link>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
